<template>
  <div class="app">
    <AppHeader/>
    <div class="app-body">
      <Sidebar/>
      <main class="main" @click="hidesidebar">
        <breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside/>
    </div>
    <AppFooter/>
  </div>
</template>

<script>
//import nav from '../_nav'
import { Header as AppHeader, Sidebar, Aside as AppAside, Footer as AppFooter, Breadcrumb } from '../components/'

export default {
  name: 'full',
  components: {
    AppHeader,
    Sidebar,
    AppAside,
    AppFooter,
    Breadcrumb
  },
  data () {
    return {
  //    nav: nav.items
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    }
  },
  methods:{
	hidesidebar(){
						
			var checkbox1 = document.getElementById("checkbox1");
			if(checkbox1!=null)
				 if(document.body.offsetWidth<768)
				 {
					 if( checkbox1.checked==true ){
				   checkbox1.checked=false
				   $(".v-sidebar-menu").css("left","-270px");
					 $(".sidebar-fixed .main, .sidebar-fixed .app-footer").css("margin-left","0px");
				   }
				 }	
		},
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Full.vue?26594f46